var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "hero is-primary is-fullheight" }, [
    _c("div", { staticClass: "hero-body is-centered" }, [
      _c(
        "form",
        {
          staticClass: "columns is-multiline",
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.onSubmit($event)
            }
          }
        },
        [
          _vm.topUrlRedirect
            ? _c("div", { staticClass: "column is-12 is-centered" }, [
                _c(
                  "a",
                  { attrs: { href: _vm.topUrlRedirect, target: "__blank" } },
                  [_c("img", { attrs: { src: _vm.topBannerImg } })]
                )
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "column is-12" },
            [
              _c("Receiver", {
                attrs: { "is-loading": _vm.isLoading, inline: true }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "column is-12" },
            [_c("PlainConcepts", { attrs: { "is-loading": _vm.isLoading } })],
            1
          ),
          _c("div", { staticClass: "column is-12 action-buttons" }, [
            _c("div", { staticClass: "field is-grouped" }, [
              _c("p", { staticClass: "control" }, [
                _c(
                  "button",
                  {
                    staticClass: "button is-success",
                    class: { "is-loading": _vm.isLoading },
                    attrs: { type: "submit", disabled: _vm.isLoading }
                  },
                  [_vm._v("\n              Generar Factura\n            ")]
                )
              ])
            ])
          ]),
          _vm.bottomUrlRedirect
            ? _c("div", { staticClass: "column is-12 is-centered" }, [
                _c(
                  "a",
                  { attrs: { href: _vm.bottomUrlRedirect, target: "__blank" } },
                  [_c("img", { attrs: { src: _vm.bottomBannerImg } })]
                )
              ])
            : _vm._e()
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }